export enum PatientsNotInFile {
    Ignore = 1,
    Deactivate = 2
}